import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { MbProductTabReferencesAdapter } from './mb-product-tab-references.adapter'
import { MbProductTabReference } from '../../../models'

@Injectable({
  providedIn: 'root',
})
export class MbProductTabReferencesConnector {

  constructor (protected adapter: MbProductTabReferencesAdapter) {
  }

  get (productCode: string, maxCount?: number): Observable<MbProductTabReference[]> {
    return this.adapter.load(productCode, maxCount)
  }
}
